import { getFeature } from 'Cloud/Application/FeaturesEs6';

/** CLOUDWEB-18871 Список расширений, на которых надо показывать тултип редактрования доков в аттачах */
export const editDocumentsInAttachesExts: string[] = getFeature('edit-documents-in-attaches-exts') || [];
